import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../reducers/types";
import { withRouter } from "react-router";
import { PackagesInfoModal } from "./component";

const mapStateToProps = (_: IStoreState) => ({});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PackagesInfoModalConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedPackagesInfoModal = withRouter(
  connector(PackagesInfoModal)
);
